/* tslint:disable */
/* eslint-disable */
/**
 * Ordering Api
 * Its4 Plan Ordering Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WeeklyThroughput
 */
export interface WeeklyThroughput {
    /**
     * 
     * @type {number}
     * @memberof WeeklyThroughput
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyThroughput
     */
    week: number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyThroughput
     */
    totalDoneAmount: number;
}

/**
 * Check if a given object implements the WeeklyThroughput interface.
 */
export function instanceOfWeeklyThroughput(value: object): value is WeeklyThroughput {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('week' in value) || value['week'] === undefined) return false;
    if (!('totalDoneAmount' in value) || value['totalDoneAmount'] === undefined) return false;
    return true;
}

export function WeeklyThroughputFromJSON(json: any): WeeklyThroughput {
    return WeeklyThroughputFromJSONTyped(json, false);
}

export function WeeklyThroughputFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyThroughput {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'week': json['week'],
        'totalDoneAmount': json['totalDoneAmount'],
    };
}

  export function WeeklyThroughputToJSON(json: any): WeeklyThroughput {
      return WeeklyThroughputToJSONTyped(json, false);
  }

  export function WeeklyThroughputToJSONTyped(value?: WeeklyThroughput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'week': value['week'],
        'totalDoneAmount': value['totalDoneAmount'],
    };
}

